import { MbConstants } from '../mb-constants'

export const sortStamps = (unsortedStamps?: string[]) => {
  let result: string[] = []
  let skipStamps = false
  unsortedStamps?.forEach((stamp: string) => {
    if (MbConstants.FINAL_STOCK_LABEL.toLowerCase().includes(stamp?.toLowerCase())) {
      result = []
      result.push(stamp)
      skipStamps = true
    } else if (!skipStamps) {
      if (MbConstants.HIGHLIGHT_LABEL.toLowerCase().includes(stamp?.toLowerCase())) {
        result.unshift(stamp)
      } else {
        result.push(stamp)
      }
    }
  })
  return result
}
